import React, { Component } from 'react';
import Text from './text';
import styles from '../styles/scss/components/checkboxNew.module.scss';
import cn from 'classnames';

export default class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stateValue: this.props.value ? true : false

        }
    }
    
    handleClick(e) {
        const { onClick } = this.props;
        const { stateValue } = this.state;
        this.setState({ stateValue: !stateValue }, () => {
            if (onClick) onClick(this.state.stateValue);
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ 
            stateValue: nextProps.value ? true : false
        });
    }
    render() {
        const { name, text, style, className, 'aria-label': ariaLabel } = this.props;
        const { stateValue } = this.state;

        return (
            <div 
                className={cn(styles.container, className)} 
                style={style} 
                tabIndex={0} 
                role="checkbox"
                aria-checked={stateValue}
                aria-label={ariaLabel}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        this.handleClick(e);
                    }
                }}
                onClick={this.handleClick.bind(this)}
            >
                    <div className={cn(styles.box)} >
                        { stateValue &&                         
                            <div className={cn(styles.active)}>
                                <i className='fa fa-check' aria-hidden="true" />
                            </div>
                        }
                    </div>
                    
                {text && <Text value={text} className={styles.title} />}
            </div>
        );
    }
}
